module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-started-form"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.05),
      expression: "0.05"
    }],
    staticClass: "custom-started-form__background",
    style: ({
      backgroundImage: 'url(' + _vm.props.background + ')'
    })
  }, [_c('div', {
    staticClass: "custom-started-form__overlay"
  }), _c('div', {
    staticClass: "custom-started-form__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointText
      }),
      expression: "{ active: true, callback: onWaypointText }"
    }],
    staticClass: "custom-started-form__waypoint"
  }), _c('div', {
    staticClass: "custom-started-form__tagline",
    class: {
      'fade': _vm.fadeText
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.tagline)
    }
  }), _c('a', {
    staticClass: "custom-started-form__form",
    attrs: {
      "href": _vm.props.link_1,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.text_1)
    }
  }), _c('a', {
    staticClass: "custom-started-form__form",
    attrs: {
      "href": _vm.props.link_2,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.text_2)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-056c7747","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-started-form/custom-started-form.pug
// module id = 540
// module chunks = 1